import React from 'react'
import { Link } from 'react-router-dom'

import zelai from '../../../assets/images/zelai horizontal.png'

export default function () {
	return (
		<Link className="flex items-center space-x-2" to="/">
			<img
				src={zelai}
				alt="ZelAI"
				className="h-14 object-contain"
			/>
		</Link>
	)
}
